// Utils/Navigator.js
let navigator = null;

export const setNavigator = (navFn) => {
    navigator = navFn;
};

export const navigate = (path, options = {}) => {
    if (navigator) {
        navigator(path, options);
    } else {
        console.warn("Navigator is not set yet");
    }
};
